<template>
  <div class="login">
    <ul class="tabs">
      <li class="active"><router-link :to="wxLoginUri">微信登录</router-link></li>
      <li><router-link :to="loginUri">账号登录</router-link></li>
    </ul>
    <div class="image-wrap">
      <div id="login_container"></div>
    </div>
  </div>
</template>

<script>
import CheckSign from '@/components/CheckSign'
export default {
  name: 'WxLogin',
  extends: CheckSign,
  methods: {
    // 初始化微信登录二维码
    initWechatQr () {
      let state = ''
      if (this.sign != null) {
        state = this.sign.appId + '|' + this.sign.redirectUri + '|' + this.sign.digest
      }
      if (this.payload != null) {
        state = state + '|' + this.payload
      }
      new WxLogin({
        self_redirect: false,
        id: 'login_container',
        appid: 'wxe8ca109374d61a2a',
        scope: 'snsapi_login',
        redirect_uri: 'http://passport.adjustrd.com/wxlogin/handler',
        state,
        style: window.theme === 'black' ? 'white' : 'black',
        href: 'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwOHB4O21hcmdpbi10b3A6MDt9Ci5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9Ci5pbXBvd2VyQm94IC5pbmZvIHt3aWR0aDogMjA4cHg7fQouaW1wb3dlckJveCAuc3RhdHVzIHt0ZXh0LWFsaWduOiBjZW50ZXI7fQ=='
      })
    }
  },
  mounted () {
    this.initWechatQr()
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/style/login/login";
.image-wrap {
  text-align: center;
  padding-top: 40px;
  height: 315px;
  overflow: hidden;
}
#login_container {
  iframe {
    height: 300px;
  }
}
</style>
